export default __webpack_public_path__ + "static/fall1 (6)-bc80695efb8a942cded5f0fae1995b6d.jpeg";